export const WIDE_TYPE_CLASS = "wide";
export const MOBILE_WIDE_TYPE_CLASS = "mobileWide";
export const DESKTOP_WIDE_TYPE_CLASS = "desktopWide";
export const DEFAULT_TYPE_CLASS = "default";
